export default "__VITE_ASSET__ae679363__"